module.exports = __webpack_public_path__ + "static/media/seriousAutoAccident.ebee3f82.mp3";